function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { getText, getTextSerializersFromSchema, posToDOMRect, Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import tippy from 'tippy.js';

var FloatingMenuView = /*#__PURE__*/function () {
  function FloatingMenuView(_ref) {
    var _this = this;

    var editor = _ref.editor,
        element = _ref.element,
        view = _ref.view,
        _ref$tippyOptions = _ref.tippyOptions,
        tippyOptions = _ref$tippyOptions === void 0 ? {} : _ref$tippyOptions,
        shouldShow = _ref.shouldShow;

    _classCallCheck(this, FloatingMenuView);

    this.preventHide = false;

    this.shouldShow = function (_ref2) {
      var view = _ref2.view,
          state = _ref2.state;
      var selection = state.selection;
      var $anchor = selection.$anchor,
          empty = selection.empty;
      var isRootDepth = $anchor.depth === 1;
      var isEmptyTextBlock = $anchor.parent.isTextblock && !$anchor.parent.type.spec.code && !$anchor.parent.textContent && $anchor.parent.childCount === 0 && !_this.getTextContent($anchor.parent);

      if (!view.hasFocus() || !empty || !isRootDepth || !isEmptyTextBlock || !_this.editor.isEditable) {
        return false;
      }

      return true;
    };

    this.mousedownHandler = function () {
      _this.preventHide = true;
    };

    this.focusHandler = function () {
      // we use `setTimeout` to make sure `selection` is already updated
      setTimeout(function () {
        return _this.update(_this.editor.view);
      });
    };

    this.blurHandler = function (_ref3) {
      var event = _ref3.event;

      var _a;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = _this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
        return;
      }

      if ((event === null || event === void 0 ? void 0 : event.relatedTarget) === _this.editor.view.dom) {
        return;
      }

      _this.hide();
    };

    this.tippyBlurHandler = function (event) {
      _this.blurHandler({
        event: event
      });
    };

    this.editor = editor;
    this.element = element;
    this.view = view;

    if (shouldShow) {
      this.shouldShow = shouldShow;
    }

    this.element.addEventListener('mousedown', this.mousedownHandler, {
      capture: true
    });
    this.editor.on('focus', this.focusHandler);
    this.editor.on('blur', this.blurHandler);
    this.tippyOptions = tippyOptions; // Detaches menu content from its current parent

    this.element.remove();
    this.element.style.visibility = 'visible';
  }

  _createClass(FloatingMenuView, [{
    key: "getTextContent",
    value: function getTextContent(node) {
      return getText(node, {
        textSerializers: getTextSerializersFromSchema(this.editor.schema)
      });
    }
  }, {
    key: "createTooltip",
    value: function createTooltip() {
      var editorElement = this.editor.options.element;
      var editorIsAttached = !!editorElement.parentElement;

      if (this.tippy || !editorIsAttached) {
        return;
      }

      this.tippy = tippy(editorElement, _objectSpread({
        duration: 0,
        getReferenceClientRect: null,
        content: this.element,
        interactive: true,
        trigger: 'manual',
        placement: 'right',
        hideOnClick: 'toggle'
      }, this.tippyOptions)); // maybe we have to hide tippy on its own blur event as well

      if (this.tippy.popper.firstChild) {
        this.tippy.popper.firstChild.addEventListener('blur', this.tippyBlurHandler);
      }
    }
  }, {
    key: "update",
    value: function update(view, oldState) {
      var _a, _b, _c;

      var state = view.state;
      var doc = state.doc,
          selection = state.selection;
      var from = selection.from,
          to = selection.to;
      var isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);

      if (isSame) {
        return;
      }

      this.createTooltip();
      var shouldShow = (_a = this.shouldShow) === null || _a === void 0 ? void 0 : _a.call(this, {
        editor: this.editor,
        view: view,
        state: state,
        oldState: oldState
      });

      if (!shouldShow) {
        this.hide();
        return;
      }

      (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.setProps({
        getReferenceClientRect: ((_c = this.tippyOptions) === null || _c === void 0 ? void 0 : _c.getReferenceClientRect) || function () {
          return posToDOMRect(view, from, to);
        }
      });
      this.show();
    }
  }, {
    key: "show",
    value: function show() {
      var _a;

      (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      var _a;

      (_a = this.tippy) === null || _a === void 0 ? void 0 : _a.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a, _b;

      if ((_a = this.tippy) === null || _a === void 0 ? void 0 : _a.popper.firstChild) {
        this.tippy.popper.firstChild.removeEventListener('blur', this.tippyBlurHandler);
      }

      (_b = this.tippy) === null || _b === void 0 ? void 0 : _b.destroy();
      this.element.removeEventListener('mousedown', this.mousedownHandler, {
        capture: true
      });
      this.editor.off('focus', this.focusHandler);
      this.editor.off('blur', this.blurHandler);
    }
  }]);

  return FloatingMenuView;
}();

var FloatingMenuPlugin = function FloatingMenuPlugin(options) {
  return new Plugin({
    key: typeof options.pluginKey === 'string' ? new PluginKey(options.pluginKey) : options.pluginKey,
    view: function view(_view) {
      return new FloatingMenuView(_objectSpread({
        view: _view
      }, options));
    }
  });
};
/**
 * This extension allows you to create a floating menu.
 * @see https://tiptap.dev/api/extensions/floating-menu
 */


var FloatingMenu = Extension.create({
  name: 'floatingMenu',
  addOptions: function addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: 'floatingMenu',
      shouldShow: null
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    if (!this.options.element) {
      return [];
    }

    return [FloatingMenuPlugin({
      pluginKey: this.options.pluginKey,
      editor: this.editor,
      element: this.options.element,
      tippyOptions: this.options.tippyOptions,
      shouldShow: this.options.shouldShow
    })];
  }
});
export { FloatingMenu, FloatingMenuPlugin, FloatingMenuView, FloatingMenu as default };